import React from "react";
import { GoPlusCircle } from "react-icons/go";
import useTitanApp from "../../../../../../../hooks/useTitanApp";
import { Skeleton } from "@mui/material";
import {
  setShowAddPatientConditionModal,
  setCurrentPatientConditionRelatedToEdit,
  setCurrentPatientConditionRelatedToDelete,
} from "../../../../../../../dispatchers/patientDispatchers";
import { LuDot } from "react-icons/lu";
import { RxDotFilled } from "react-icons/rx";
import { MdOutlineEdit } from "react-icons/md";
import { FaRegTrashAlt } from "react-icons/fa";

export default function PatientRelatedConditions() {
  const { appState, patientState } = useTitanApp();
  const { darkMode } = appState || {};
  const {
    patientConditionRelated,
    patientCondtionRelatedLoading,
    isConsultationEnabled,
  } = patientState || {};

  const handleEditClick = async (conditionRelated) => {
    setShowAddPatientConditionModal(true);
    setCurrentPatientConditionRelatedToEdit(conditionRelated);
  };
  const handleDeleteClick = async (conditionRelated) => {
    setCurrentPatientConditionRelatedToDelete(conditionRelated);
  };

  return (
    <div className="patient-items-wrapper">
      <div className="header-title">
        <h6>Medical Conditions</h6>
        <div
          className="add-vital-btn"
          onClick={() => {
            if (!isConsultationEnabled) {
              setShowAddPatientConditionModal(true);
            }
          }}
        >
          <GoPlusCircle />
          <p>Add Condition</p>
        </div>
      </div>
      <div className="list-items vitals-list">
        {patientCondtionRelatedLoading
          ? Array.from({ length: 5 }).map((_, index) => (
              <div key={index} className="list-item sk">
                <Skeleton
                  width={150}
                  height={50}
                  animation="wave"
                  sx={{ bgcolor: darkMode ? "grey.800" : "" }}
                />
                <Skeleton
                  width={200}
                  height={30}
                  animation="wave"
                  sx={{ bgcolor: darkMode ? "grey.800" : "" }}
                />
              </div>
            ))
          : patientConditionRelated?.map((conditionRelated, index) => (
              <div className="pc-leftpanel-list-item" key={`${index}`}>
                <div className="d-flex">
                  <div className="first">
                    <div className="icon-box">
                      <div className="dot"></div>
                    </div>

                    <div className="vital-details">
                      <p>{conditionRelated?.conditionName}</p>
                      <p>{conditionRelated?.additionalComments}</p>
                      <p>
                        {conditionRelated?.diagnosedDate
                          ? `Diagnosed: ${new Date(
                              conditionRelated.diagnosedDate
                            ).toLocaleDateString("en-GB")}`
                          : ""}
                      </p>
                    </div>
                  </div>
                  <div className="type">
                    <p
                      style={{
                        backgroundColor:
                          conditionRelated?.status === 1
                            ? "#dcfce7"
                            : conditionRelated?.status === 2
                            ? "#ffedd5"
                            : conditionRelated?.status === 3
                            ? "#fee2e2"
                            : "",
                        color:
                          conditionRelated?.status === 1
                            ? "#829079"
                            : conditionRelated?.status === 2
                            ? "#c2410c"
                            : conditionRelated?.status === 3
                            ? "#b91c1c"
                            : "",
                      }}
                    >
                      {conditionRelated?.status === 1
                        ? "Chronic"
                        : conditionRelated?.status === 2
                        ? "Active"
                        : conditionRelated?.status === 3
                        ? "Resolved"
                        : ""}
                    </p>
                  </div>
                </div>
                <div className="a-actions">
                  <MdOutlineEdit
                    color="grey"
                    size={20}
                    className="icons-pointer pc-action-icons"
                    onClick={() => handleEditClick(conditionRelated)}
                  />
                  <FaRegTrashAlt
                    color="red"
                    size={15}
                    className=" icons-pointer pc-action-icons"
                    onClick={() => handleDeleteClick(conditionRelated)}
                  />
                </div>
              </div>
            ))}
      </div>
    </div>
  );
}
